module.exports = __webpack_public_path__ + "static/media/facebook_icon.aff95ad5.svg";